import { render, staticRenderFns } from "./monitor.vue?vue&type=template&id=28eb1d22&scoped=true&"
import script from "./monitor.vue?vue&type=script&lang=ts&"
export * from "./monitor.vue?vue&type=script&lang=ts&"
import style0 from "./monitor.vue?vue&type=style&index=0&id=28eb1d22&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28eb1d22",
  null
  
)

export default component.exports